import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { validate, ValidationError } from 'class-validator';
import * as FileSaver from 'file-saver';
import { ColumnMode } from '@swimlane/ngx-datatable';

import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { AlertService } from '../services/alert.service';

import { SimuladorConsumosDet } from './../entities/simuladorConsumoDet.entity';
import { Respuesta } from './../entities/respuesta.entity';
import { Contrato } from '../entities/contrato.entity';
import { SimuladorConsumoDetallado } from '../entities/simuladorConsumoDetallado.entity';

@Component({
  selector: 'app-simulador',
  templateUrl: './simuladorConsumo.component.html'
})
export class SimuladorConsumoComponent implements OnInit {

  public contratoCod: number;
  public numHab: string;
  public consumo: string;
  public rowsOnPage = 6;
  // public datosSimulador: SimuladorConsumos = new SimuladorConsumos();
  public datosSimuladorDetallado: SimuladorConsumoDetallado[] = new Array<SimuladorConsumoDetallado>();
  public datosSimulador: SimuladorConsumosDet = new SimuladorConsumosDet();
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public resultado: Respuesta;
  public direccionSuministro: string;
  public numHabInputError: boolean;
  public consumoInputError: boolean;
  public DatosObtenidos = false;
  public contrato: Contrato;
  constructor(private userService: UserService, private sessionService: SessionService,
    private alertService: AlertService, private router: Router) { }

  ngOnInit() {
    if (this.sessionService.isAuthenicated === true) {
      this.clearInputErrors();
      // this.datosSimulador = new SimuladorConsumos();
      this.datosSimulador = new SimuladorConsumosDet();
      this.datosSimulador.simConsumoDetallado = new Array<SimuladorConsumoDetallado>();
      this.contrato = this.sessionService.contratoSelected;
      this.contratoCod = this.sessionService.contratoSelected.Codigo;
      this.direccionSuministro = this.sessionService.contratoSelected.InmuebleBO.Direccion;
      this.userService.getSimuladorConsumos(
        this.sessionService.explotacion,
        this.sessionService.contratoSelected.Codigo
      ).then(response => this.cargarTextos(response));
    } else {
      this.router.navigate(['/']);
    }
  }

  public recibirContrato(event): void {
    let contratoSelect: Contrato = event.contratoSeleccionado;
    this.contratoCod = event.contratoSeleccionado.Codigo;
    this.direccionSuministro = event.contratoSeleccionado.InmuebleBO.Direccion;
    this.clearInputErrors();
  }

  public cargarTextos(response: SimuladorConsumosDet) {
    this.datosSimulador.TextoAyuda = response.TextoAyuda;
    this.datosSimulador.ConsumoFrecuencia = response.ConsumoFrecuencia;
  }

  public enviarSimulacion() {
    const textos = this.datosSimulador.TextoAyuda;
    const tipofrecuencia = this.datosSimulador.ConsumoFrecuencia;
    const nombre = this.datosSimulador.contratoNombre;
    this.datosSimulador = new SimuladorConsumosDet();
    this.datosSimulador.TextoAyuda = textos;
    this.datosSimulador.ConsumoFrecuencia = tipofrecuencia;
    this.datosSimulador.contratoNombre = nombre;

    this.clearInputErrors();
    this.datosSimulador.NumHab = this.numHab;
    this.datosSimulador.Consumo = this.consumo;
    this.datosSimulador.Contrato = this.contratoCod;
    this.datosSimulador.contratoNombre = this.sessionService.contratoSelected.ClienteNombre;

    validate(this.datosSimulador).then(resultado => {
      if (resultado.length > 0) {
        this.showErrors(resultado);
      } else {
        // this.userService.generarSimulacion(this.sessionService.explotacion, this.datosSimulador)
        //   .then(
        //     response => this.generarSimulacionOnSuccess(response),
        //     response => this.generarSimulacionOnError(response)
        //   );

        this.userService.generarSimulacionDetallado(this.sessionService.explotacion, this.datosSimulador)
          .then(
            response => this.generarSimulacionOnSuccess(response),
            response => this.generarSimulacionOnError(response)
          );
      }
    });
  }

  public generarSimulacionOnSuccess(response) {
    let resultadoSimulador: SimuladorConsumosDet = response;
    this.datosSimulador = resultadoSimulador;
    this.datosSimuladorDetallado = resultadoSimulador.simConsumoDetallado;
    this.DatosObtenidos = true;
    this.updateDataSource();
    this._showModal = true;
  }

  public generarSimulacionOnError(response) {
    this.resultado = response;
    this.messageCabecera = 'Error en la simulación de los consumos';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al simular los consumos';
      this.typeException = 1;
    }
  }

  public descargarSimulacion() {
    this.userService.descargarSimulacion(this.sessionService.explotacion, this.datosSimulador)
      .then(
        response => this.descargarSimulacionOnSuccess(response),
        response => this.descargarSimulacionOnError(response)
      );
  }

  public descargarSimulacionOnSuccess(response) {
    let fichero: Blob = response;
    let filename = 'simulacion.pdf';
    FileSaver.saveAs(fichero, filename);
  }

  public descargarSimulacionOnError(response) {
    this.resultado = response;
    this.messageCabecera = 'Error en al descargar';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al descargar la simulación de los consumos';
      this.typeException = 1;
    }
  }

  public showErrors(resultado: ValidationError[]) {
    for (let item of resultado) {
      switch (item.property) {
        case 'Consumo':
          this.consumoInputError = true;
          break;
        case 'NumHab':
          this.numHabInputError = true;
      }
    }
  }

  public clearInputErrors() {
    this.numHabInputError = false;
    this.consumoInputError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  @ViewChild('myTable') table: any;

  private _colID = 'id';
  private displayedColumns = [
    'Servicio', 'ImporteServicio', 'Impuesto', 'ImporteTotal'
  ];

  data: SimuladorConsumoDetallado[] = [];
  rows: any[] = [];
  isMobile = false;
  _tableFullscreen = false;
  _columnMode = ColumnMode.flex;

  @HostListener('window:resize', ['$event'])
  onResize(event = null) {
    const windowWidth = event !== null ? event.target.innerWidth : window.innerWidth;
    this.isMobile = windowWidth < 800;
  }

  private updateDataSource() {
    this.data = this.datosSimuladorDetallado;
    if (this.displayedColumns.length > 0) {
      let i = 0;
      this.rows = [];
      const _dataLength = this.data.length;
      while (i < _dataLength) {
        let item = {};
        let _id = this.data[i]['id'];
        if (_id === undefined) { _id = i; }
        item[this._colID] = _id;
        this.data[i][this._colID] = _id;
        this.displayedColumns.forEach((dc: string) => {
          item[dc.toLowerCase()] = this.getDataValue(this.data[i][dc]);
        });
        this.rows.push(item);
        i++;
      }
    }
  }

  private getDataValue(dataItem: any) {
    return dataItem === undefined || dataItem === null ? '' : dataItem;
  }

  getRowItem(row: any) {
    const id = row[this._colID];
    const currentItem = this.data.find(d => d.id === id);
    return currentItem;
  }

  parseStringToInt(val: string) {
    return parseInt(val);
  }

  getConsumo(datosSimulador: any) {
    return `${datosSimulador.ConsumoFrecuencia} (m<sup>3</sup>)`;
  }

  // MODAL

  _showModal = false;

  showModal() {
    return this._showModal;
  }

  closeModal() {
    this._showModal = false;
    this.clearInputErrors();
  }
}
